import { isObject, get, isFunction, isMap, isString, isNumber } from 'lodash';
import transText from './transText.js';

function renderTextFromDataSource(config, dataSource, defaultText) {
  if (defaultText === void 0) {
    defaultText = '-';
  }
  var dataIndex = config.dataIndex,
    render = config.render,
    valueEnum = config.valueEnum;
  if (!isObject(dataSource)) {
    return defaultText;
  }
  var text = get(dataSource, dataIndex);
  if (isFunction(render)) {
    return render(text, dataSource);
  }
  if (isMap(valueEnum)) {
    var value = valueEnum.get(text);
    return transText(value, defaultText);
  }
  if (isObject(valueEnum)) {
    // @ts-ignore todo
    var value = valueEnum[text];
    return transText(value, defaultText);
  }
  if (isString(text) || isNumber(text)) {
    return text;
  }
  return defaultText;
}

export { renderTextFromDataSource as default };
